export const RichTextToolbarConfig = {
    options: ['inline', 'fontSize', 'list'],
    inline: {
        options: ['bold', 'italic', 'underline'],
    },
    list: { options: ['unordered', 'ordered'] },
};

export const CALL_TO_ACTION_TYPE = {
    LINK: 'link',
    BUTTON: 'button',
};
